/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ModalError[data-edge-to-edge=true][_ngcontent-%COMP%]{padding:16px}@media (min-width:768px){.ModalError[data-edge-to-edge=true][_ngcontent-%COMP%]{padding:32px}}.ModalError-actions[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}.ModalError-details[_ngcontent-%COMP%]{word-break:break-word;word-wrap:break-word;background-color:#f0f0f0;border-radius:3px;padding:16px 24px}.ModalError-icon[_ngcontent-%COMP%]{pointer-events:none}.ModalError-retryBtn[_ngcontent-%COMP%]{min-width:140px}"];
export { styles as styles };
